<script>

	import { mapState, mapActions } from 'vuex'

	import Page from '@/containers/Page/Page'

	import Questions from '@/components/Questions/Questions'
	import BuyBox from '@/components/BuyBox/BuyBox'

	import './style.scss'

	export default {
		name: 'company',
		components: {
			Page,
			Questions,
			BuyBox,
		},
		computed: {
			...mapState({
				'company': state => state.user.company,
				'restricted': state => state.user.restrictedQuestions,
				'isLoggedIn': state => state.user.isLoggedIn,
				'registered': state => state.user.registered,
				'questions': state => state.user.questions,
			}),
			showBuyBox() {
				return (this.restricted === true ||
							 (this.isLoggedIn === false &&
								this.registered === false)
				)
			}
		},
		created () {
			this.$store.dispatch('setCompany', this.$route.params.company);
			if (!!this.company) {
				this.$store.dispatch('fetchCompanyQuestions', {
					company: this.company,
				})
			}
		},
		watch: {
			registered(isRegistered) {
				if (isRegistered === true) {
					this.$store.dispatch('fetchCompanyQuestions', {
						company: this.$route.params.company,
					})
				}
			},
			restricted(isRestricted) {
				if (isRestricted === false) {
					this.$store.dispatch('fetchCompanyQuestions', {
						company: this.$route.params.company,
					})
				}
			},
		},
		methods: {
			...mapActions([
				'setCompany'
			])
		}
	}

</script>

<template>
	<Page class='company-flow'>
		<img class='logo' :src='`/static/companies/${company}.svg`'>
		<BuyBox v-if='showBuyBox' :company='company'/>
		<div class='container'>
			<Questions :questions='questions' />
		</div>
	</Page>
</template>



// WEBPACK FOOTER //
// src/flows/Company/Company.vue